import { render, staticRenderFns } from "./CloneModal.vue?vue&type=template&id=1380b0e3"
import script from "./CloneModal.vue?vue&type=script&lang=js"
export * from "./CloneModal.vue?vue&type=script&lang=js"
import style0 from "./CloneModal.vue?vue&type=style&index=0&id=1380b0e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports